(function(){
  'use strict';

  if (window._untamed_search_bar_loaded) return; 
  window._untamed_search_bar_loaded = true;

  const SECTION_SELECTOR = '.search-bar-section';
  const INPUT_SELECTOR = '.search-bar__input';
  const DROPDOWN_SELECTOR = '.search-bar__dropdown';
  const RESULTS_INNER_SELECTOR = '[data-results-inner]';
  const OVERLAY_SELECTOR = '[data-overlay]';
  const CLEAR_SELECTOR = '.search-bar__clear';

  const debounce = (fn, delay = 160) => {
    let id; return (...args) => { clearTimeout(id); id = setTimeout(() => fn(...args), delay); };
  };

  const buildResultItem = (item) => {
    const url = item.url || item.website_url;
    const title = item.title || item.name;
    const image = item.image || item.image_url;
    const imageSrc = image?.url || image?.src || image || null;
    return `
      <a class="search-bar__item" href="${url}">
        ${imageSrc ? `<img class=\"search-bar__thumb\" alt=\"\" src=\"${imageSrc}&width=96\">` : `<div class=\"search-bar__thumb\"></div>`}
        <div class="search-bar__item-content">
          <div class="search-bar__item-title">${title}</div>
        </div>
      </a>`;
  };

  const renderResults = (root, payload) => {
    const resultsInner = root.querySelector(RESULTS_INNER_SELECTOR);
    const products = payload?.resources?.results?.products || [];
    const collections = payload?.resources?.results?.collections || [];
    if (!products.length && !collections.length) { resultsInner.innerHTML = ''; return false; }
    const productHtml = products.length ? `
      <div class="search-bar__group">
        <div class="search-bar__group-title">Products</div>
        <div class="search-bar__list">${products.map(buildResultItem).join('')}</div>
      </div>` : '';
    const collectionHtml = collections.length ? `
      <div class="search-bar__group">
        <div class="search-bar__group-title">Collections</div>
        <div class="search-bar__list">${collections.map(buildResultItem).join('')}</div>
      </div>` : '';
    resultsInner.innerHTML = `${productHtml}${collectionHtml}`;
    return true;
  };

  const toggleUI = (root, show) => {
    const dropdown = root.querySelector(DROPDOWN_SELECTOR);
    const overlay = root.querySelector(OVERLAY_SELECTOR);
    dropdown.hidden = !show; 
    overlay.hidden = !show;
    
    // Prevent background scrolling when overlay is open
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };

  const fetchPredictive = async (query, { limitProducts, limitCollections } = {}) => {
    const params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'product,collection');
    if (limitProducts) params.set('resources[limit]', String(limitProducts));
    const url = `/search/suggest.json?${params.toString()}`;
    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Search request failed');
    return res.json();
  };

  const setup = (section) => {
    const input = section.querySelector(INPUT_SELECTOR);
    const clearBtn = section.querySelector(CLEAR_SELECTOR);
    const overlay = section.querySelector(OVERLAY_SELECTOR);
    
    const handleQuery = debounce(async (value) => {
      const q = value.trim();
      if (!q) { 
        section.querySelector(RESULTS_INNER_SELECTOR).innerHTML=''; 
        toggleUI(section, false); 
        if (clearBtn) clearBtn.hidden = true;
        return; 
      }
      try {
        const payload = await fetchPredictive(q, {
          limitProducts: Number(section.dataset.limitProducts) || 6,
          limitCollections: Number(section.dataset.limitCollections) || 4,
        });
        const hasResults = renderResults(section, payload);
        toggleUI(section, !!hasResults); 
        if (clearBtn) clearBtn.hidden = false;
      } catch (e) { toggleUI(section, false); }
    }, 200);

    if (input) {
      input.addEventListener('input', (e) => handleQuery(e.target.value));
    }
    
    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        input.value=''; 
        input.focus(); 
        section.querySelector(RESULTS_INNER_SELECTOR).innerHTML=''; 
        toggleUI(section, false); 
        clearBtn.hidden = true;
      });
    }
    
    if (overlay) {
      overlay.addEventListener('click', () => toggleUI(section, false));
    }
  };

  document.querySelectorAll(SECTION_SELECTOR).forEach(setup);
})();


